import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

// Générer les options d'heures entre min et max avec un pas de 30 minutes
const generateTimeOptions = (min, max) => {
  const options = [];
  for (let hour = min.HOUR; hour <= max.HOUR; hour++) {
    const startMinute = hour === min.HOUR ? min.MINUTE : 0;
    const endMinute = hour === max.HOUR ? max.MINUTE + 30 : 60;

    for (let minute = startMinute; minute < endMinute; minute += 30) {
      const timeString =
      `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      options.push(timeString);
    }
  }
  return options;
};

export default function TimeSelector({
  label,
  value,
  onChange,
  min,
  max,
  fullWidth = true,
}) {
  const timeOptions = generateTimeOptions(min, max);

  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        if (newValue) {
          onChange(newValue);
        }
      }}
      options={timeOptions}
      fullWidth={fullWidth}
      disableClearable
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          inputProps={{
            ...params.inputProps,
            placeholder: 'HH:MM',
          }}
        />
      )}
    />
  );
}
